module.exports = __webpack_public_path__ + "static_pc/img/contectBg.c204df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/contectBg.jpg
// module id = bqbU
// module chunks = 1